import React, { FC } from "react";
import { darkTheme } from "@yleisradio/yds-core";
import { Play } from "@yleisradio/yds-icons-react";
import styled, { css } from "styled-components";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import { secondsToHHMMSSFormat } from "../../helpers/timeHelpers";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";

const SmallWrapper = styled.div`
  bottom: 16px;
  left: 16px;
  position: absolute;
`;

const SmallPlayButtonStyled = styled.button<{
  hasDuration?: boolean;
  isMobile: boolean;
}>`
  align-items: center;
  background: ${darkTheme.BACKGROUND_NEGATIVE};
  border-radius: 54px;
  border: 2px solid ${darkTheme.BORDER};
  color: ${darkTheme.TEXT_NEGATIVE};
  cursor: pointer;
  display: flex;
  font:
    700 12px "Yle Next",
    "Open Sans",
    sans-serif;
  height: ${({ isMobile }) => (isMobile ? "32px" : "40px")};
  line-height: 18px;
  width: auto;

  &:hover,
  &:focus {
    border: 2px solid ${darkTheme.BORDER_PRIMARY_FOCUS};
  }

  svg {
    height: 18px;
    margin-right: ${({ hasDuration }) => (hasDuration ? "8px" : "0")};
    width: 18px;
  }

  ${({ hasDuration, isMobile }) =>
    isMobile
      ? css`
          height: 32px;
          padding: ${hasDuration ? "0 12px" : "0 5px"};
        `
      : css`
          height: 40px;
          padding: ${hasDuration ? "0 14px" : "0 9px"};
        `}
`;

export const SmallPreviewPlayButton: FC = () => {
  const { useStoreState } = usePlayerStore();
  const device = useStoreState.device();
  const durationInSeconds = useStoreState.durationInSeconds();
  const isLive = useStoreState.isLive();
  const player = useStoreState.player();

  const { language } = useEmbedParametersContext();

  const durationInSecondsFormatted = secondsToHHMMSSFormat(durationInSeconds);

  return (
    <SmallWrapper>
      <SmallPlayButtonStyled
        aria-keyshortcuts="k"
        aria-label={i18n("toista_aria_label", { language })}
        isMobile={device.isMobile}
        hasDuration={!isLive && !!durationInSecondsFormatted}
        onClick={() => player.play()}>
        <Play />
        {!isLive && durationInSecondsFormatted}
      </SmallPlayButtonStyled>
    </SmallWrapper>
  );
};
